'use strict';
import {createActions} from '../../framework';

const normalActions = ['CLOSE_MOBILE_MENU', 'OPEN_MOBILE_MENU'];

const subheaderActions = createActions(null, normalActions);

export default subheaderActions;
